import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandIcon from '@wix/da-ds/pkg/Icons/Expand';
import ShrinkIcon from '@wix/da-ds/pkg/Icons/Shrink';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { useDeviationViewContext } from '../../../Context';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
export const ExpandButton = ({ canFullscreen, deviation, onClick })=>{
    const { t } = useTranslation();
    const { isFullscreen } = useDeviationViewContext();
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t(`actionbar.${isFullscreen ? 'regular' : 'expand'}View${canFullscreen ? '' : '.disabled'}`)
    }, /*#__PURE__*/ React.createElement(ActionBarButton, {
        onClick: ()=>onClick(deviation),
        disabled: !canFullscreen
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: isFullscreen ? ShrinkIcon : ExpandIcon
    })));
};
ExpandButton.displayName = 'ExpandButton';
export default ExpandButton;

//# sourceMappingURL=ExpandButton.js.map